import { PaginatedResponse, User } from '@arpeggi/shared'
import axios from '../../../__legacy__/lib/axios'
import { BasePaginationParams } from '../types'

export const getSamplePackRemixers = async (samplePackId: number, params: BasePaginationParams) => {
  const { data } = await axios.get<PaginatedResponse<User>>(
    `/api/v2/sample-packs/${samplePackId}/remixers`,
    { params }
  )

  return data
}
